<template>
  <div
    class="TradeClientOrderForm"
    style="background-color: rgb(238, 238, 238)"
  >
    <v-container>
      <v-row justify="center">
        <v-col cols="12" md="10" xl="6">
          <v-card color="transparent">
            <v-card-title class="text-center">
              <div class="text-center mx-auto">
                <span class="bold product-title pr-2">Delivery </span>
                <span class="product-title"> Details Form</span>
              </div>
            </v-card-title>

            <v-card-text>
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="email"
                      :rules="emailRules"
                      label="Email Address:"
                      required
                      color="gray"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="project"
                      label="Project/Client Reference:"
                      color="gray"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="name"
                      :rules="required"
                      label="Name"
                      required
                      color="gray"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="streetAddress"
                      label="Street Address"
                      :rules="required"
                      color="gray"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="city"
                      label="City"
                      :rules="required"
                      color="gray"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="state"
                      label="State"
                      :rules="required"
                      color="gray"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="zipCode"
                      label="Zip Code"
                      :rules="required"
                      color="gray"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="contactPhone"
                      label="Contact Phone Number"
                      :rules="required"
                      color="gray"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="secondaryPhone"
                      label="Secondary Contact Phone Number"
                      color="gray"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" class="radio-control">
                    <v-radio-group
                      v-model="ResidentialOrCommercial"
                      label="Residential or Commercial"
                      :rules="required"
                      color="grey"
                    >
                      <v-radio
                        label="Residential (white glove)"
                        value="Residential (white glove)"
                        color="grey"
                      ></v-radio>
                      <v-radio
                        label="Residential (curbside)"
                        value="Residential (curbside)"
                        color="grey"
                      ></v-radio>
                      <v-radio 
                        label="Commercial (must have loading dock and/or forklift)" 
                        value="Commercial (must have loading dock and/or forklift)" 
                        color="grey"
                      ></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="6" class="radio-control">
                    <v-radio-group
                      v-model="groundLevelDelivery"
                      label="Ground/Street level delivery (no stairs or elevator)"
                      :rules="required"
                      color="grey"
                    >
                      <v-radio
                        label="Yes"
                        value="Yes"
                        color="grey"
                      ></v-radio>
                      <v-radio
                        label="No"
                        value="No"
                        color="grey"
                      ></v-radio>
                    </v-radio-group>
                  </v-col>
                  <v-col cols="12" md="6" class="radio-control">
                    <v-radio-group
                      v-model="stairsRequired"
                      label="Are stairs required to reach destination floor?"
                      :rules="required"
                      color="grey"
                    >
                      <v-radio
                        label="Yes"
                        value="Yes"
                        color="grey"
                      ></v-radio>
                      <v-radio
                        label="No"
                        value="No"
                        color="grey"
                      ></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="6" class="radio-control">
                    <v-text-field
                      v-model="flightsStairs"
                      label="How many flights of stairs?"
                      color="gray"
                      type="number"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12" class="radio-control">
                    <v-radio-group
                      v-model="largeCapacity"
                      label="Will a freight (or large capacity) elevator be required to reach destination floor?"
                      :rules="required"
                      color="grey"
                    >
                      <v-radio
                        label="Yes"
                        value="Yes"
                        color="grey"
                      ></v-radio>
                      <v-radio
                        label="No"
                        value="No"
                        color="grey"
                      ></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="additionalEmails"
                      label="Additional Emails for notifications"
                      color="gray"
                    ></v-text-field>
                  </v-col>
                </v-row>

              </v-form>
            </v-card-text>
            <v-card-actions class="py-0 px-0">
              <v-btn
                color="black"
                block
                dark
                tile
                class="mr-4"
                @click="validate"
                :ripple="false"
                elevation="0"
              >
                send &nbsp; <span class="bold white--text ml-1">request</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
export default {
    data () {
        return {
            valid : false,
            date: null,
            menu: false,
            radioGroup: null,
            email: '',
            emailRules: [
                v => !!v || 'E-mail is required',
                v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
            ],
            required: [
                v => !!v || 'Required'
            ],
            project: '',
            name: '',
            requirements: '',
            billingAddress: '',
            streetAddress: '',
            city: '',
            state: '',
            zipCode: '',
            contactPhone: '',
            secondaryPhone: '',
            ResidentialOrCommercial: '',
            groundLevelDelivery: '',
            stairsRequired: '',
            flightsStairs: '',
            largeCapacity: '',
            additionalEmails: '',
            files: []
        }
    },
    watch: {
      menu (val) {
        val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
      },
    },
    methods: {
      save (date) {
        this.$refs.menu.save(date)
      },
      validate () {
        if(this.$refs.form.validate()){
          var aux = this;

        let data = {
          Email: aux.email,
          Project: aux.project,
          Name: aux.name,
          Street: aux.streetAddress,
          City: aux.city,
          State: aux.state,
          ZipCode: aux.zipCode,
          ContactPhone: aux.contactPhone,
          SecondaryPhone: aux.secondaryPhone,
          ResidentialOrCommercial: aux.ResidentialOrCommercial,
          GroundLevelDelivery: aux.groundLevelDelivery,
          StairsRequired: aux.stairsRequired,
          FlightsStairs: aux.flightsStairs,
          LargeCapacity: aux.largeCapacity,
          AdditionalEmails: aux.additionalEmails
        };

        fetch(
          "https://www.artlesscms.actstudio.xyz/api/forms/submit/DeliveryDetails?token=cf00a9204acb3ab54e671ca7655e5f",
          {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              form: data,
            }),
          }
        )
          .then((entry) => entry.json())
          .then((entry) => console.log(entry))
          .then(this.copiaCollection(data))
          .then(this.reiniciar());
        }
      },
      copiaCollection: function (formData){
        fetch('https://www.artlesscms.actstudio.xyz/api/collections/save/DeliveryDetailsForm', {
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                data: formData
            })
        })
        .then(res=>res.json());
      },
      reiniciar: function () {
        this.$emit("openSnackbar");

        this.$router.push("/");
      },
    }
}
</script>